module.exports = __webpack_public_path__ + "media/19.56ebaf35.mp3";